import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './shared/tokens.css'
import './styles.css'
import './style-exploration.css'
import './themes.css'
import { initializeTheme } from './theme'

const initialRoute = window.location.hash.startsWith('#/') ? window.location.hash.slice(1) : '/'

initializeTheme()

void router.replace(initialRoute).then(() => {
  createApp(App).use(router).mount('#app')
})
